import React from 'react'

class Intro extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="intro intro--shortenMore">
        {/*<img src="/images/illustrations/playVS_gameroom.jpg" />*/}
        <div className="container">
          <div className="intro__content">
            <h1>Featured Games</h1>
            <p>
              Our games focus on skills that are required in traditional high school sports, such as offensive and defensive strategy, dexterity, critical-thinking, and teamwork.
            </p>
          </div>
        </div>
        {/*<div className="intro__mask intro__mask--fadeToRight"></div>*/}
      </div>
    )
  }
}

export default Intro



// WEBPACK FOOTER //
// ./src/common/ui/components/IntroGames.js